<div class="add-container">
  <h1 class="add-title">Adaugă departament</h1>
  <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
    <div class="add-field">
      <mat-form-field appearance="fill">
        <mat-label>Nume departament</mat-label>
        <input type="text" matInput formControlName="name" />
        <mat-error
          *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="add-field">
      <mat-form-field appearance="fill">
        <mat-label>Descriere departament</mat-label>
        <input type="text" matInput formControlName="description" />
        <mat-error
          *ngIf="
            !form.controls['description'].valid &&
            form.controls['description'].touched
          "
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
    <div class="add-action-btns">
      <button
        class="buttons"
        type="button"
        mat-flat-button
        (click)="closeDialog()"
      >
        Close
      </button>
      <button class="buttons" type="submit" mat-flat-button color="primary">
        Save
      </button>
    </div>
  </form>
</div>
